import styled from 'styled-components/macro';

export const SwitchLabel = styled.label`
  background: #c1c9ca;
  border-radius: 15px;
  cursor: pointer;
  height: 10px;
  left: 0;
  position: absolute;
  top: 7px;
  width: 35px;
  z-index: -1;

  &::after {
    background: var(--chakra-colors-text-default);
    border-radius: 50%;
    content: '';
    display: block;
    height: 16px;
    margin-top: -4px;
    width: 16px;
    transition: 0.2s;
  }
`;
